import { TgMembership } from '@core/dto';

interface AuthInterface {
  accessToken?: string;
  isAuthenticated?: boolean;
  tgMemberships?: TgMembership[] | [];
  isPwdChangeNeeded?: boolean;
  pwdChangeCycleMonth?: number;
  refreshToken?: string;
  // membershipId?: string;
}

export class AuthModel {
  accessToken: string;
  isAuthenticated: boolean;
  tgMemberships: TgMembership[] | [];
  isPwdChangeNeeded?: boolean;
  pwdChangeCycleMonth?: number;
  refreshToken?: string;
  // membershipId: string;

  constructor({
    accessToken,
    isAuthenticated,
    tgMemberships = [],
    isPwdChangeNeeded,
    pwdChangeCycleMonth,
    refreshToken,
  }: AuthInterface) {
    this.accessToken = accessToken ?? '';
    this.isAuthenticated = isAuthenticated ?? false;
    this.tgMemberships = tgMemberships;
    this.isPwdChangeNeeded = isPwdChangeNeeded ?? false;
    this.pwdChangeCycleMonth = pwdChangeCycleMonth ?? 0;
    this.refreshToken = refreshToken ?? '';
    // this.membershipId = this.getMembershipId();
  }
  static createFromResponse(response: any): AuthModel {
    const {
      accessToken,
      tgMemberships,
      isPwdChangeNeeded,
      pwdChangeCycleMonth,
      refreshToken,
    } = response;
    return new AuthModel({
      accessToken,
      isAuthenticated: true,
      tgMemberships,
      isPwdChangeNeeded,
      pwdChangeCycleMonth,
      refreshToken,
    });
  }

  static createEmpty(): AuthModel {
    return new AuthModel({ accessToken: '', isAuthenticated: false });
  }

  getMembershipId(): string {
    if (this.tgMemberships.length === 0) return '';
    return this.tgMemberships[0].membershipId;
  }

  getAccessToken(): string {
    return this.accessToken;
  }

  getPasswordChangeCycle(): number | null {
    return this.isPwdChangeNeeded ? this.pwdChangeCycleMonth ?? null : null;
  }

  getStdBizCode(): string {
    return this.tgMemberships[0]?.stdBizCode ?? '';
  }

  getMemberships(): TgMembership[] {
    return this.tgMemberships;
  }

  signIn(accessToken: string): void {
    this.accessToken = accessToken;
  }
  signOut(): void {
    this.accessToken = '';
  }
}
